













































































import branchs from '@/store/types/branchs';
import commerce from '@/store/types/commerce';
import DatesFormat from '@/util/classes/datesFormat';
import image from '@/assets/images/no-image-available.png';
import { itemsRoute, navLink } from '@/ts/navegationLinks';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'Branchs',
  data: () => ({
    image,
    items: [
      {
        id: 1,
        icon: 'ni ni-shop',
        title: 'Perfil',
        route: 'users-branch-profile',
        hash: 'perfil',
        can: 'show_commerces',
      },
      {
        id: 2,
        icon: 'ni ni-circle-08',
        title: 'Contactos',
        route: 'users-branch-contacts',
        hash: 'contactos',
        can: 'index_contacts',
      },
      {
        id: 3,
        icon: 'ni ni-badge',
        title: 'Usuarios',
        route: 'users-braches',
        hash: 'usuarios',
        can: 'index_users',
      },
      {
        id: 4,
        icon: 'fa fa-cash-register',
        title: 'POS',
        route: 'pos-braches',
        hash: 'pos',
        can: 'index_point_of_sales',
      }
    ] as itemsRoute[],
    navlink: [] as navLink[],
    loading: true,
  }),
  computed: {
    ...mapGetters({
      getSingleBranch: `commerceModule/branches/${branchs.getters.GET_SINGLE_BRANCH}`,
      getSingleCommerce: `commerceModule/${commerce.getters.GET_SINGLE_COMMERCE}`,
    }),
  },
  async mounted() {
    this.filledNavLinks();
    await this.singleBranch(this.$route.params.sucursal_id);
    await this.singleCommerce(this.$route.params.commerce_id);
    this.loading = false;
  },
  methods: {
    ...mapActions({
      singleBranch: `commerceModule/branches/${branchs.actions.SINGLE_BRANCH}`,
      singleCommerce: `commerceModule/${commerce.actions.SINGLE_COMMERCE}`,
    }),
    filledNavLinks() {
      this.navlink = [
        {
          name: `${this.$t('menu.commerce.plural.formal')} afiliados`,
          active: false,
          to: '/commerce/partners',
        },
        {
          name: 'Información de comercio',
          active: false,
          to: `/commerce/partners/${this.$route.params.commerce_id}`,
        },
        {
          name: 'Sucursales',
          active: true,
        }
      ];
    },
    createdAt(date: string) {
      const dateFormat = new DatesFormat();
      return dateFormat.formatDate(date);
    },
    logoImage(url: string | null) {
      if (!url) {
        return this.image;
      }
      return url;
    },
  },
});
